import { render, staticRenderFns } from "./MainEmergency.vue?vue&type=template&id=fe5fa6ea&scoped=true"
import script from "./MainEmergency.vue?vue&type=script&lang=js"
export * from "./MainEmergency.vue?vue&type=script&lang=js"
import style0 from "./MainEmergency.vue?vue&type=style&index=0&id=fe5fa6ea&prod&scoped=true&lang=css"
import style1 from "./MainEmergency.vue?vue&type=style&index=1&id=fe5fa6ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe5fa6ea",
  null
  
)

export default component.exports